import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const gridCss = ".grid{--count:0;--appear:0;--gap:0;--grid-auto-flow:auto;--grid-template-columns-multiplier:0;--grid-template-columns:none;--grid-template-columns-appear:none;--grid-template-rows-multiplier:0;--grid-template-rows:none;--grid-template-rows-appear:none;display:grid;gap:var(--gap);grid-auto-flow:var(--grid-auto-flow);margin-left:calc(-1 * var(--appear) * var(--gap) * var(--grid-template-columns-multiplier));margin-right:0;margin-top:calc(-1 * var(--appear) * var(--gap) * var(--grid-template-rows-multiplier));margin-bottom:0;grid-template-columns:var(--grid-template-columns);grid-template-columns-rows:var(--grid-template-rows);transition:700ms}.grid.appeared{margin-left:0;margin-right:calc(-1 * var(--appear) * var(--gap) * var(--grid-template-columns-multiplier));margin-top:0;margin-bottom:calc(-1 * var(--appear) * var(--gap) * var(--grid-template-rows-multiplier));grid-template-columns:var(--grid-template-columns-appear);grid-template-rows:var(--grid-template-rows-appear)}.grid ::slotted(tt-video-card){min-width:0%}";

const gapSizes = {
  none: '0',
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
};
const Grid = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.mode = 'column';
    this.count = 4;
    this.appear = 0;
    this.appearDelay = 1000;
    this.gap = 'md';
  }
  render() {
    const style = {
      '--appear': this.appear + '',
      '--count': this.count + '',
      '--gap': this.gap
        .split(' ')
        .map((g) => { var _a; return (_a = gapSizes[g]) !== null && _a !== void 0 ? _a : g; })
        .join(' '),
      '--grid-auto-flow': this.mode === 'row' ? 'column' : 'row',
    };
    style[`--grid-template-${this.mode}s-multiplier`] = '1';
    if (this.appear > 0) {
      (style[`--grid-template-${this.mode}s`] = ('0fr '.repeat(this.appear) + '1fr '.repeat(this.count)).trim()),
        (style[`--grid-template-${this.mode}s-appear`] = ('1fr '.repeat(this.count) + '0fr '.repeat(this.appear)).trim()),
        window.setTimeout((() => {
          this.element.className += ' appeared';
        }).bind(this), this.appearDelay);
    }
    else {
      // If not, then we want a plain an orderly grid
      style[`--grid-template-${this.mode}s`] = `repeat(${this.count}, 1fr)`;
    }
    return (h("div", { ref: (el) => (this.element = el), class: "grid", style: style }, h("slot", null)));
  }
  static get style() { return gridCss; }
}, [1, "tt-grid", {
    "mode": [1],
    "count": [2],
    "appear": [2],
    "appearDelay": [2, "appear-delay"],
    "gap": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-grid"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-grid":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, Grid);
      }
      break;
  } });
}

export { Grid as G, defineCustomElement as d };
